module.exports = __webpack_public_path__ + "static/media/backlight12.a021d2e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Backlight/backlight12.png
// module id = 312
// module chunks = 0